document.querySelector('.contact .toggle').addEventListener('click', (e) => {
	e.currentTarget
		.closest('.contact')
		.querySelector('.buttons')
		.classList.toggle('show')
})
